import {
  createContext,
  type PropsWithChildren,
  useEffect,
  useState,
} from 'react';

import '../../tokens/fonts/lausanne-pan.css';
import '../../tokens/tokens.css';
// Imported after tokens.css: its rules read --ui-* and, being equal-specificity with
// nothing, rely on the tokens already being declared.
import '../../tokens/chakra-bridge.css';

export const UIPortalContext = createContext<HTMLElement>(document.body);

type UIThemeProps = PropsWithChildren<{
  portalId?: string;
}>;

export const UITheme = ({ children, portalId }: UIThemeProps) => {
  const [container, setContainer] = useState<HTMLElement>(document.body);

  useEffect(() => {
    const el = portalId ? document.getElementById(portalId) : document.body;
    if (el) {
      setContainer(el);
    }
  }, [portalId]);

  return (
    <UIPortalContext.Provider value={container}>
      {children}
    </UIPortalContext.Provider>
  );
};
